import {
    IAcompanhamentosVistoria,
    IAcompanhamentoVistoriaFiltro,
} from "../../../Interfaces/VistoriaEntregaChaves/AcompanhamentosVistoria/AcompanhamentosVistoriaInterfaces";
import { AcompanhamentoVistoriaService } from "../../../Services/VistoriaEntregaChaves/AcompanhamentosVistoria/AcompanhamentosVistoriaService";
import { Controller } from "../../Controller";

export async function AcompanhamentoVistoriaController(
    filtro: IAcompanhamentoVistoriaFiltro
) {
    return Controller<IAcompanhamentosVistoria>(
        AcompanhamentoVistoriaService(filtro)
    );
}

export async function AcompanhamentoVistoriaExportarExcelController(
    filtro: IAcompanhamentoVistoriaFiltro
) {
    return Controller<Blob>(AcompanhamentoVistoriaService(filtro, true));
}
